<div [innerHTML]="sanitizedCode | safe : 'html'"
     (domChange)="onDomChange()"
     data-automation-id="custom-section" class="custom-section">
</div>
